import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad9c2da0&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ad9c2da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9c2da0",
  null
  
)

export default component.exports